import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('感谢订阅！我们会将最新护肤资讯发送到您的邮箱。');
      setEmail('');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      formData.delete('phone_alt');
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const response = await fetch('https://readdy.ai/api/form/d9u4h55ca23r0tr1aqd0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会将最新护肤资讯发送到您的邮箱。');
        setEmail('');
      } else if (serverMsg && (typeof serverMsg === 'string') && serverMsg.toLowerCase().includes('spam')) {
        setStatus('error');
        setMessage('提交失败，请稍后再试。');
      } else {
        setStatus('error');
        setMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查您的连接后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-accent-500">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-2">
          <i className="ri-mail-send-line text-4xl text-white/80"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-3">
          订阅护肤资讯
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          每周推送最新护肤干货、季节护肤技巧和独家美容指南，让美丽不缺席。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
          <div className="relative flex-1 w-full">
            <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="w-full pl-11 pr-4 py-3.5 rounded-full bg-white text-foreground-900 placeholder-foreground-400 text-sm focus:outline-none focus:ring-2 focus:ring-white/50 transition-all"
            />
          </div>
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-7 py-3.5 bg-foreground-900 text-white font-medium rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap text-sm disabled:opacity-60 cursor-pointer w-full sm:w-auto"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {message && (
          <p
            className={`mt-4 text-sm ${
              status === 'success' ? 'text-white/90' : 'text-red-200'
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}